{
    "warning": "హెచ్చరిక!",
    "message": "మీకు అర్థం కాని కోడ్‌ని ఎంటర్ లేదా పేస్ట్ చేయకండి.\nఈ కన్సోల్‌ని ఉపయోగించడం వలన దాడి చేసేవారు మిమ్మల్ని అనుకరిస్తూ మరియు Self-XSS అనే దాడిని ఉపయోగించి మీ సమాచారాన్ని దొంగిలించవచ్చు."
}
